import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MiaAuthHttpService, AuthenticationService } from '@mobileia/authentication';
import { Observable } from 'rxjs';
import { ApiResponse, ApiPagination, MIATableModel } from '@mobileia/core';
import { environment } from 'src/environments/environment';
import { Slider } from '../entities/slider';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root'
})
export class SliderService extends BaseTableService<Slider> {

  constructor(
    protected http: HttpClient,
    protected authService: AuthenticationService
  ) {
    super(http, authService);
    this.basePathUrl = 'admin/slider';
  }
  
}
